import { useEffect } from 'react';
import { Spin } from 'antd';
import { keycloak } from '../auth/keycloak';
import { useT } from '../locales';

export function LogoutPage() {
  const t = useT();
  useEffect(() => {
    keycloak.logout({ redirectUri: window.location.origin + '/login' });
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Spin description={t('auth.loggingOut')} size="large" />
    </div>
  );
}
